import styled, { css } from 'styled-components';

const ellipsisStyle = css`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

interface CardWrapperProps {
	disabled?: boolean;
	hasOnClick?: () => void; // function is passed as a boolean
}

export const BasicHorizontalCardWrapper = styled.div<CardWrapperProps>`
	display: flex;
	border-radius: 9px;
	cursor: ${({ disabled, hasOnClick }) => {
		if (disabled) return 'not-allowed';
		if (hasOnClick) return 'pointer';
		return 'default';
	}};
	background-color: var(--basic-horizontal-card, var(--sidebar-box), rgba(var(--base-11), 1));
	position: relative;
`;

interface TextWrapperProps {
	customColor?: string;
	disabled?: boolean;
	truncate?: boolean;
}

export const TextWrapper = styled.div<TextWrapperProps>`
	> * {
		${({ customColor, disabled }) =>
			customColor &&
			!disabled &&
			css`
				color: ${customColor};
			`}
		${({ disabled }) =>
			disabled &&
			css`
				width: 250px !important;
			`}
	${({ truncate }) => truncate && ellipsisStyle}
	}
`;

interface ImageWrapperProps {
	height?: string;
}

export const ImageWrapper = styled.div<ImageWrapperProps>`
	overflow: hidden;
	border-radius: 9px 0 0 9px;
	width: ${({ height }) => height || '76px'};
	height: ${({ height }) => height || '76px'};
	position: relative;

	> img {
		border-radius: 3px 0 0 3px;
		object-fit: cover;
	}
`;

interface BasicHorizontalCardDetailsWrapperProps {
	height?: string;
	withPadding?: boolean;
}

export const BasicHorizontalCardDetailsWrapper = styled.figcaption<BasicHorizontalCardDetailsWrapperProps>`
	padding: 8px ${({ withPadding }) => (withPadding ? '40px' : '4px')} 8px 12px;
	border-radius: 0 3px 3px 0;
	position: relative;
	flex: 1;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	height: ${({ height }) => height || '72px'};
`;

interface ButtonWrapperProps {
	buttonBgColor?: string;
	disabled?: boolean;
}

export const ButtonWrapper = styled.div<ButtonWrapperProps>`
	height: 36px;
	width: 36px;
	border-radius: 50%;
	background-color: ${({ buttonBgColor }) =>
		buttonBgColor || 'var(--basic-horizontal-card-button-wrapper-bg, rgba(var(--primary), 1))'};
	border: ${({ buttonBgColor }) =>
		buttonBgColor ? 'none' : '1px solid var(--basic-horizontal-card-button-wrapper-border)'};
	display: flex;
	justify-content: center;
	align-items: center;
	align-self: center;
	margin-right: 12px;

	svg {
		fill: var(--basic-horizontal-card-button-svg-fill);
	}

	${({ disabled }) =>
		disabled &&
		css`
			visibility: hidden;
		`}
`;

interface ActionContentWrapperProps {
	disabled?: boolean;
	position?: 'start' | 'center' | 'end';
}

export const ActionContentWrapper = styled.div<ActionContentWrapperProps>`
	display: flex;
	justify-content: ${({ position }) => position || 'center'};
	align-items: ${({ position }) => position || 'center'};
	margin: 6px 0;
	position: absolute;
	right: 0;
	top: ${({ position }) => (position === 'center' ? '27%' : 0)};

	> * {
		${({ disabled }) => (disabled ? '' : 'filter: var(--filter-secondary)')}
	}

	.icon--sprite {
		${({ disabled }) => (disabled ? '' : 'fill: rgba(var(--basic-horizontal-card-icon-fill, var(--primary)), 1)')}
	}
`;

export const BadgeWrapper = styled.div`
	position: absolute;
	right: 12px;
	bottom: 12px;
	span {
		text-transform: none;
	}
`;

export const ImageTextWrapper = styled.div`
	position: absolute;
	bottom: 0;
	width: 100%;
	text-align: center;
	margin-bottom: 3px;
`;
